import React from "react";
import { Flex, Text, Divider, Loader, Card, Grid } from "@mantine/core";
import { format } from "date-fns";
import { ko } from "date-fns/locale";
import { CardContainerRetro } from "../Container/CardContainerRetro";
import { IconClock } from "@tabler/icons-react";
import colorsCustom from "../../designTokens/colorsCustom";
import { useTranslation } from "react-i18next";

const ScheduledPostsList = ({ scheduledPosts, loadingPosts, openEditModal }) => {
  const { t } = useTranslation();
  
  return (
    <>
      {/* 예약된 스레드 목록 */}
      <Divider style={{ width: "100%", margin: "16px 0 8px 0" }} />
      <Text
        size="2xl"
        weight={900}
        style={{ width: "100%", marginBottom: "8px" }}
      >
        {t("postThreads.scheduledThreadsTitle")}
      </Text>

      {loadingPosts ? (
        <Flex justify="center" align="center" style={{ padding: "20px" }}>
          <Loader />
        </Flex>
      ) : scheduledPosts.length > 0 ? (
        <Grid gutter={16} style={{ width: "100%" }}>
          {scheduledPosts.map((post, index) => {
            // Firestore 데이터 모델에 맞게 데이터 추출
            const taskId = post.id || `task_${index}`;
            // executeAt을 Date 객체로 변환 (KST 시간)
            const scheduleTime = post.executeAt 
              ? new Date(post.executeAt + ' GMT+0900')
              : new Date();
            // createdAt 또는 scheduledAt을 사용
            const createTime = post.scheduledAt 
              ? new Date(post.scheduledAt)
              : (post.createdAt ? new Date(post.createdAt) : new Date());
            // Firestore 필드에서 직접 추출
            const postText = post.text || "내용 없음";
            const userID = post.userID || "알 수 없음";
            const replies = post.replies || [];

            return (
              <Grid.Col key={taskId} span={4}>
                <CardContainerRetro
                  w={"100%"}
                  rd={12}
                  borderType={"full"}
                  onClick={() => {
                    openEditModal({
                      id: taskId,
                      text: postText,
                      executeAt: scheduleTime,
                      replies: replies,
                      userID: userID,
                    });
                  }}
                  style={{ cursor: "pointer", minHeight: 220 }}
                >
                  <Flex
                    p={"20px 20px 16px 20px"}
                    w={"100%"}
                    bg={colorsCustom.paper}
                    direction={"column"}
                    gap={24}
                    br={4}
                  >
                    <Flex direction={"row"} justify={"space-between"} align={"center"} h={28}>
                      <Flex gap={8} align={"center"}>
                        <IconClock size={22} color={colorsCustom.ui.dark.moderate} />
                        <Text size="lg" fw={700} lh={1} c={"gray.4"}>
                          {format(scheduleTime, "MM/dd", { locale: ko })}
                        </Text>
                        <Text size="lg" fw={700} lh={1} c={"gray.4"}>
                          {format(scheduleTime, "EEE", { locale: ko })}
                        </Text>
                        <Text size="lg" fw={700} lh={1} c={"gray.4"}>
                          {format(scheduleTime, "HH:mm", { locale: ko })}
                        </Text>
                      </Flex>
                      <Flex gap={4} direction={"row"} align={"center"}>
                        <Text size="lg" c="dimmed" fw={700}>
                          {t(`postThreads.status.${post.status || 'scheduled'}`)}
                        </Text>
                      </Flex>
                    </Flex>
                    <Text
                      ff={'"source-han-serif-korean", "Noto Serif KR", "Noto Serif CJK KR", "Source Han Serif KR", "Apple SD Gothic Neo", "Malgun Gothic", "맑은 고딕", serif'}
                      lh={1.55}
                      size="2xl"
                      h={64}
                      fw={900}
                      w="100%"
                      c={colorsCustom.ui.dark.bold}
                      style={{ overflow: "hidden" }}
                    >
                      {postText.split(".")[0].replace(/�/g, "")}
                    </Text>
                    {/* 댓글 정보 표시 */}
                    {replies && replies.length > 0 && (
                      <Flex
                        gap={8}
                        c={colorsCustom.ui.dark.moderate}
                        wrap={"wrap"}
                      >
                        <Text size="md" c="dimmed" fw={600}>
                          {t("postThreads.autoReplyCount", { count: replies.length })}
                        </Text>
                        <Text size="md" lineClamp={1} c="gray.6">
                          {replies[0]}
                          {replies.length > 1 ? ` ... 외 ${replies.length - 1}개` : ""}
                        </Text>
                      </Flex>
                    )}
                    {/* 생성 시간 정보 */}
                    <Text size="md" c="dimmed">
                      {t("postThreads.createdAt", { date: format(createTime, "MM/dd HH:mm", { locale: ko }) })}
                    </Text>
                  </Flex>
                </CardContainerRetro>
              </Grid.Col>
            );
          })}
        </Grid>
      ) : (
        <Card
          shadow="sm"
          padding="xl"
          radius="md"
          withBorder
          style={{ 
            width: "100%",
            textAlign: "center",
            backgroundColor: "#f8f9fa"
          }}
        >
          <Text c="dimmed" size="lg">
            {t("postThreads.noScheduledThreads")}
          </Text>
          <Text c="dimmed" size="md" mt={4}>
            {t("postThreads.noScheduledThreadsSub")}
          </Text>
        </Card>
      )}
    </>
  );
};

export default ScheduledPostsList; 